"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventContentType = void 0;
var EventContentType;
(function (EventContentType) {
    EventContentType["folder"] = "folder";
    EventContentType["file"] = "file";
    EventContentType["url"] = "url";
    EventContentType["article"] = "article";
    EventContentType["livedoc"] = "livedoc";
    EventContentType["datasource"] = "datasource";
    EventContentType["livedoccomponent"] = "livedoccomponent";
    EventContentType["emailtemplate"] = "email-template";
    EventContentType["emailtemplatecomponent"] = "email-template-component";
    EventContentType["unknown"] = "unknown";
})(EventContentType = exports.EventContentType || (exports.EventContentType = {}));
//# sourceMappingURL=EventContentType.js.map